'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoMan = function IoMan(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20.1 8.4c-1.7 0-2.9-1.4-2.9-3s1.2-2.9 2.9-2.9 2.9 1.2 2.9 2.9-1.3 3-2.9 3z m2.9 0.6c2.1 0 3.6 1.9 3.6 3.7v8.9c0 1.8-2.5 1.8-2.5 0v-8.2h-0.4v22.4c0 2.2-3.2 2.4-3.3 0v-12.9h-0.6v12.9c-0.1 2.2-3.4 2.3-3.4 0v-22.4h-0.5v8.2c0 1.8-2.4 1.8-2.4 0v-8.9c0-1.8 1.5-3.7 3.7-3.7h5.8z' })
        )
    );
};

exports.default = IoMan;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/man.js
// module id = 2376
// module chunks = 0